import { TourPageGallery } from 'views/shared/tours/page/gallery';
import { AboutWrapper } from './about';
import { GlanceWrapper } from './glance';
import { BookingDetails } from './booking_details';
import { Price } from './price';
import './index.scss';

export default {
  Gallery: TourPageGallery,
  About: AboutWrapper,
  Glance: GlanceWrapper,
  BookingDetails,
  Price,
};
